import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import { IGameVersion } from '../../../model/gameVersion/GameVersion';
import { useRootStore } from '../../../loaders/useRootStore';
import { useGetCategoriesLink } from '../../routes';
import { useNavigate } from 'react-router-dom';
import styles from './GameVersionSelector.module.sass';
import { ClaimType } from '@yakoffice/publisher-types';
import { ButtonGroup } from 'react-bootstrap';


interface PropsType {
    [key: string]: any,

    selectedGameVersion?: IGameVersion,
    handleGameVersionChange?: (targetGameVersion: IGameVersion) => void,
}

export const GameVersionSelector: FC<PropsType> = observer(({
                                                                selectedGameVersion,
                                                                handleGameVersionChange,
                                                                className,
                                                                ...props
                                                            }) => {
    const rootStore = useRootStore();
    const navigate = useNavigate();
    const getCategoriesLink = useGetCategoriesLink();

    const onGameVersionChange = (targetGameVersion: IGameVersion) => {

        if (targetGameVersion.name.toLowerCase() === 'staticdata') {
            const devGameEnvironmentId = rootStore.gameEnvironmentsStore.gameEnvironments.find(gameEnvironment => gameEnvironment.name.toLowerCase() === 'dev')?.id;
            rootStore.gameEnvironmentsStore.setCurrentGameEnvironment(devGameEnvironmentId !== undefined ? devGameEnvironmentId : rootStore.gameEnvironmentsStore.getCurrentGameEnvironment().id);
        }

        handleGameVersionChange
            ? handleGameVersionChange(targetGameVersion)
            : navigate(getCategoriesLink({ gameVersionId: targetGameVersion.id }));
    };

    const selectedGameVersionOrDefault = selectedGameVersion ?? rootStore.gameVersionStore.getCurrentGameVersion();

    const title = () => {
        return (
            <>
                <i
                    className="fas fa-code-branch" /> {selectedGameVersionOrDefault.name}
            </>
        );
    };
    const staticDataSelector = () => {

        const staticDataGameVersion = rootStore.gameVersionStore.gameVersions.find(gameVersion => gameVersion.name === 'staticData');

        if (staticDataGameVersion) {
            return (
                <Dropdown.Item
                    key={staticDataGameVersion.id}
                    as="button"
                    onClick={() => onGameVersionChange(staticDataGameVersion)}
                    data-testid={`gameVersionSelectorButton${staticDataGameVersion.name}`}
                >
                    {staticDataGameVersion.name}
                </Dropdown.Item>
            );
        }
    };

    return rootStore.authStore.currentAuthUser.hasProjectClaim(ClaimType.ViewAllGameVersions) ? (
        <DropdownButton
            as={ButtonGroup}
            align="end"
            title={title()}
            variant="outline-primary"
            className={`${styles.versionSelector} gameVersionSelector ${className ?? ''}`}
            data-testid={'gameVersionSelectorDropdownButton'}
            {...props}
        >
            <>
                {rootStore.gameVersionStore.gameVersions
                    .filter((gv) => !gv.isArchived())
                    .filter((gv) => !gv.isInactive())
                    .map((gameVersion) => {
                        return (
                            <Dropdown.Item key={gameVersion.id} as="button"
                                           onClick={() => onGameVersionChange(gameVersion)}
                                           data-testid={`gameVersionSelectorButton${gameVersion.name}`}>
                                {gameVersion.name}
                            </Dropdown.Item>
                        );
                    })}
                {staticDataSelector()}
            </>
        </DropdownButton>
    ) : null;
});

